// extracted by mini-css-extract-plugin
export default {"container":"SelectInputGroup_container__-EPLo","inputGroup":"SelectInputGroup_inputGroup__YAfEL","label":"SelectInputGroup_label__xV3BY","error":"SelectInputGroup_error__OeZcU"};